import { Component, Inject, Input } from '@angular/core';
import { OdConfig } from "../../od-config";
import { CheckUtils } from "../../ui-utils/check-utils";
var HTML_TEMPLATE = "\n  <div class=\"od-upload-viewer\" [attr.readonly]=\"readOnly == true ? true : null\">\n    <div class=\"od-upload-viewer-item\" *ngFor=\"let _data of _datas\">\n      <img *ngIf=\"_data.data !=null && _data.icon == null\" [src]=\"_data.data\" class=\"od-upload-viewer-img\" [title]=\"_data.name\"\n           [alt]=\"_data.name\" (click)=\"onDownload(_data)\"/>\n      <div *ngIf=\"_data.icon!=null\" [class]=\"_data.icon + ' icon-file'\" (click)=\"onDownload(_data)\">{{_data.name}}</div>\n      <ion-icon *ngIf=\"!readOnly\" name=\"remove-circle\" (click)=\"remove(_data)\" class=\"od-upload-viewer-remove\"></ion-icon>\n    </div>\n  </div>\n";
var CSS_STYLE = "\n.od-upload-viewer{\n  display: flex;\n  flex-direction:row;\n  flex-wrap: wrap;\n}\n\n.od-upload-viewer-img {\n  margin: 12px;\n  max-width: 100px;\n  max-height: 75px;\n}\n\n.icon-file{\n\tfont-size: 14px;\n    color: #1d9ac0;\n    cursor: pointer;\n    margin-top: 6px;\n    padding: 0 4px 0 0;\n    width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.icon-file:before{\n    font-size: 16px;\n    width: 100%;\n    flex-direction: column;\n    padding: 10px 10px 10px 5px;\n}\n\n.od-upload-viewer-item{\n  position: relative;\n}\n\n.od-upload-viewer-remove{\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  opacity: 0;\n  pointer-events: none;\n  color: red;\n}\n\n.od-upload-viewer[readonly] .od-upload-viewer-remove{\n\tdisplay:none;   \n}\n\n.od-upload-viewer-item:hover > .od-upload-viewer-remove{\n  opacity: 1;\n  pointer-events: auto;\n}\n\n";
var UploadViewer = /** @class */ (function () {
    function UploadViewer(config) {
        this.config = config;
        this._datas = new Set();
    }
    Object.defineProperty(UploadViewer.prototype, "datas", {
        get: function () {
            return Array.from(this._datas.values());
        },
        set: function (values) {
            if (values != null) {
                for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                    var value = values_1[_i];
                    if (!this.allowDuplicate && this.fileExists(value))
                        continue;
                    this._datas.add(value);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    UploadViewer.prototype.fileExists = function (file) {
        for (var _i = 0, _a = Array.from(this._datas.values()); _i < _a.length; _i++) {
            var f = _a[_i];
            if (f.identityKey == file.identityKey && f.name == file.name && f.icon == file.icon) {
                return true;
            }
        }
        return false;
    };
    UploadViewer.prototype.onDownload = function (data) {
        if (!CheckUtils.areEmpty(this.config, data.identityKey))
            window.open(this.config.downloadFileUrl + data.identityKey, "_blank");
    };
    UploadViewer.prototype.clean = function () {
        this._datas.clear();
    };
    UploadViewer.prototype.remove = function (data) {
        this._datas.delete(data);
    };
    UploadViewer.decorators = [
        { type: Component, args: [{
                    selector: 'od-upload-viewer',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    UploadViewer.ctorParameters = function () { return [
        { type: OdConfig, decorators: [{ type: Inject, args: ['config',] },] },
    ]; };
    UploadViewer.propDecorators = {
        "readOnly": [{ type: Input },],
        "allowDuplicate": [{ type: Input },],
        "datas": [{ type: Input },],
    };
    return UploadViewer;
}());
export { UploadViewer };
//# sourceMappingURL=upload-viewer.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/upload/upload-viewer.js
// module id = 431
// module chunks = 14